import React from "react";
import Dictionary from "./components/Dictionary";

export default function App() {
  return (
    <div className="App">
      <header>
        <h1>Advanced Dictionary</h1>
      </header>
      <main>
        <Dictionary defaultKeyword="ocean" />
      </main>
      <footer>
        <p>Built for SheCodes Project</p>
      </footer>
    </div>
  );
}